import {
  getExtraInfo,
  addExtraInfo_center,
  addExtraInfo_home,
  delete_subscribe,
  updateSubscribe,
  getSubscribeSetList,
  getSubscribeList,
  addSubscribe,
  data_authern,
  data_basic,
  add_basic,
  judge_password,
  login,
  authern_person,
  regist,
  getUserInfo,
  star,
  authern_unit,
  unStar,
  update_password,
  update_phone,
  loginPhone,
  mail_code_unvalid,
  list_applicant,
  add_applicant,
  delete_applicant,
  update_applicant,
  loginOrRegister,
  baiduOcr,
} from "@/api/account";
import { mail_code } from "@/api/common";
import { Message } from "element-ui";
import router from "@/router";
import { removeToken, setToken } from "@/common/cookie";
import { clearStorage, setStorage } from "@/common/utils";
import cookie from "js-cookie";
export default {
  namespaced: true,
  mutations: {
    setToken(state: any, data: any) {
      data ? setToken(data) : removeToken();
      data ? setStorage("token", data) : clearStorage("token");
      state.token = data;
    },
    clearToken(state: any, data: any) {
      removeToken();
      state.token = null;
    },
  },
  actions: {
    // 清除
    clear({ state, commit }: any, data: any) {
      commit("setHotCity", null, { root: true });
      commit("setRoleBasic", null, { root: true });
      commit("setAllPolicy", null, { root: true });
      commit("setNature", null, { root: true });
      commit("setDepartData", null, { root: true });
      commit("clearToken");
      commit("setBasic", null, { root: true });
    },
    async addHomeExtraInfo({ state, commit }: any, data: any) {
      const res: any = await addExtraInfo_home(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    async addCenterExtraInfo({ state, commit }: any, data: any) {
      const res: any = await addExtraInfo_center(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    async getExtraInfo({ state, commit }: any, data: any) {
      const res: any = await getExtraInfo(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    async deleteSubscribeSetting({ state, commit }: any, data: any) {
      const res: any = await delete_subscribe(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    logOut({ state, commit, dispatch }: any, data: any) {
      dispatch("clear");
      Message.success("退出成功");
    },
    updateRoleBasic({ state, commit }: any, data: any) {
      const { token } = data;
      const tempData: any = data;
      tempData.soleSave = 1;
      commit("setBasic", tempData, { root: true });
      commit("setToken", token);
      // location.reload();
    },
    // 发起登录
    async login({ state, commit, dispatch }: any, params: any) {
      const res: any = await login(params)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      const { code, message } = res;
      const data = res.result;
      if (res && code === 200) {
        const { accessToken, soleSave } = data;
        // 设置登录后的数据
        getUserInfo({}).then((res) => {
          cookie.set("userInfo", res.data.result);
          commit("setBasic", res.data.result, { root: true });
          router.push({ path: `/pcm/homePage` });
        });
        commit("setToken", accessToken);
        return res;
      }
      return res;
    },
    // 短信登录
    async loginPhone({ state, commit }: any, params: any) {
      const res: any = await loginPhone(params)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      const { code, message } = res;
      const data = res.result;
      if (res && code === 200) {
        const { accessToken, soleSave } = data;
        // 设置登录后的数据
        getUserInfo({}).then((res) => {
          cookie.set("userInfo", res.data.result);
          commit("setBasic", res.data.result, { root: true });
          router.push({ path: `/pcm/homePage` });
        });
        commit("setToken", accessToken);
        return res;
      }
      return res;
    },
    // 用户注册
    async regist({ state, commit }: any, data: any) {
      const res: any = await regist(data)
        .then((res: any) => {
          const { code, data, msg } = res.data;
          if (code === 0) {
            return true;
          }
          return false;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    // 用户注册  验证码登录
    async loginOrRegister({ state, commit }: any, data: any) {
      const res: any = await loginOrRegister(data)
        .then((res: any) => {
          console.log(res, 9999999);
          const { code, data, msg } = res.data;
          if (code === 0) {
            let { userInfo, ifExists } = data;
            userInfo.ifExists = ifExists;
            // 设置登录后的数据
            cookie.set("userInfo", userInfo);
            commit("setBasic", userInfo, { root: true });
            commit("setToken", userInfo.token);

            return true;
          }
          return false;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    // 新增订阅
    async addSubscribe({ state, commit }: any, data: any) {
      const res: any = await addSubscribe(data)
        .then(({ data }: any) => {
          return data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    async updateSubscribe({ state, commit }: any, data: any) {
      const res: any = await updateSubscribe(data)
        .then(({ data }: any) => {
          return data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    // 查询订阅列表
    async getSubscribeList({ state, commit }: any, data: any) {
      const res: any = await getSubscribeList(data)
        .then(({ data }: any) => {
          return data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    // 查询订阅设置列表
    async getSubscribeSetList({ state, commit }: any, data: any) {
      const res: any = await getSubscribeSetList(data)
        .then(({ data }: any) => {
          return data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    // 新增申报员
    async addApplicant({ state, commit }: any, data: any) {
      const res: any = await add_applicant(data)
        .then(({ data }: any) => {
          return data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    // 删除申报员
    async deleteAppicant({ state, commit }: any, data: any) {
      const res: any = await delete_applicant(data)
        .then(({ data }: any) => {
          return data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    // 修改申报员
    async updateApplicant({ state, commit }: any, data: any) {
      const res: any = await update_applicant(data)
        .then(({ data }: any) => {
          return data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    // 获取申报员列表数据
    async getApplicantList({ state, commit }: any, data: any) {
      const res: any = await list_applicant(data)
        .then(({ data }: any) => {
          return data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    // 获得短信
    async getMail({ state, commit }: any, data: any) {
      const res: any = await mail_code(data)
        .then((res: any) => {
          const { success, message } = res.data;
          if (success) {
            // const { requestId } = data;
            // return requestId;
            return success;
          }
          return false;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    // 获取无校验的短信
    async getMailUnvalid({ state, commit }: any, data: any) {
      const res: any = await mail_code_unvalid(data)
        .then((res: any) => {
          const { code, data, msg } = res.data;
          if (code === 0) {
            // const { requestId } = data;
            // return requestId;
            return data;
          }
          return false;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    // 验证手机号是否被注册
    /*async verifyPhone({ state, commit }: any, data: any) {
      const res: any = await verify_phone(data)
        .then((res: any) => {
          const { code, data, msg } = res.data;
          if (code === 0 && data) {
            return data;
          }
          return false;
        })
        .catch((e: string) => console.error(e))
      return res;
    },*/
    // 修改手机号
    async updatePhone({ state, commit }: any, data: any) {
      const res: any = await update_phone(data)
        .then((res: any) => {
          const { code, data, msg } = res.data;
          if (code === 0) {
            const { token } = data;
            commit("setBasic", data, { root: true });
            commit("setToken", token);
          }
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    // 修改密码
    async updatePassword({ state, commit }: any, data: any) {
      const res: any = await update_password(data)
        .then((res: any) => {
          // const { code, data, msg } = res.data;
          // if (code === 0) {
          //   const { token } = data;
          //   commit('setBasic', data, { root: true });
          //   commit('setToken', token);
          // }
          return res.data;
        })
        .catch((e: string) => console.error(e));
      if (!res) {
        return {
          code: -1,
          msg: "验证码输入错误",
        };
      }
      return res;
    },
    // 企业实名认证
    async unitAuthern({ state, commit }: any, data: any) {
      const res: any = await authern_unit(data)
        .then((res: any) => res.data)
        .catch((e: string) => console.error(e));
      return res;
    },
    // 用户实名认证
    async personAuthern({ state, commit }: any, data: any) {
      const res: any = await authern_person(data)
        .then((res: any) => res.data)
        .catch((e: string) => console.error(e));
      return res;
    },
    // 判断密码是否正确
    async judgePassword({ state, commit }: any, data: any) {
      const res: any = await judge_password(data)
        .then((res: any) => res.data)
        .catch((e: string) => console.error(e));
      return res;
    },
    // 获取实名信息
    // async getAuthernData({ state, rootState, commit }: any, params: any) {
    //   if (!rootState.roleBasic) {
    //     const res: any = await data_authern(params)
    //       .then((res: any) => {
    //         return res.data;
    //       })
    //       .catch((e: string) => console.error(e));
    //     const { code, data, msg } = res;
    //     if (code === 0) {
    //       commit("setRoleBasic", data, { root: true });
    //       return data;
    //     }
    //   }
    //   return rootState.roleBasic;
    // },
    // 获取基本信息
    async getBasic({ state, commit }: any, data: any) {
      const res: any = await data_basic(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    // 提交基本信息
    async addBasic({ state, commit }: any, data: any) {
      const res: any = await add_basic(data)
        .then((res: any) => {
          return res.data;
        })
        .catch((e: string) => console.error(e));
      return res;
    },
    // 关注
    async star({ state, commit }: any, data: any) {
      const res: any = await star(data)
        .then((res: any) => res.data)
        .catch((e: string) => console.error(e));
      return res;
    },
    // 取消关注
    async unStar({ state, commit }: any, data: any) {
      const res: any = await unStar(data)
        .then((res: any) => res.data)
        .catch((e: string) => console.error(e));
      return res;
    },
    // 百度ocr
    async baiduOcr({ state, commit }: any, data: any) {
      const res: any = await baiduOcr(data)
        .then((res: any) => res.data)
        .catch((e: string) => console.error(e));
      return res;
    },
  },
};
